import { Chip, TextField } from '@mui/material'
import { useOperatingUnits } from '../../../hooks/useOperatingUnits'
import styles from '../MicroLearningDetail.module.css'

type ApproveModalContentProps = {
  selectedOus: string[]
  onToggleOu: (ou: string) => void
  note: string
  onNoteChange: (value: string) => void
}

export default function ApproveModalContent({
  selectedOus,
  onToggleOu,
  note,
  onNoteChange,
}: ApproveModalContentProps) {
  const operatingUnits = useOperatingUnits()

  return (
    <>
      <div>
        <p className={styles.approveLabel}>Publishing to:</p>
        <div className={styles.ouChipsContainer}>
          {operatingUnits.map(ou => {
            const isSelected = selectedOus.includes(ou)
            return (
              <Chip
                key={ou}
                label={ou}
                size='small'
                variant='outlined'
                onClick={() => onToggleOu(ou)}
                className={isSelected ? styles.ouChipSelected : styles.ouChip}
              />
            )
          })}
        </div>
      </div>
      <TextField
        multiline
        minRows={3}
        placeholder='Add any notes about why this was approved...'
        value={note}
        onChange={e => onNoteChange(e.target.value)}
        fullWidth
        variant='outlined'
        size='small'
      />
    </>
  )
}
